<ng-container *ngFor="let inputTypeField of inputTypeFields">
  <ng-container [ngSwitch]="inputTypeField">

    <!-- Space -->
    <div *ngSwitchCase="InputFieldType.SpaceCol">
    </div>


    <!-- Divider -->
    <ng-container *ngSwitchCase="InputFieldType.Divider">
      <div *ngIf="field.showField">
        <p-divider class="p-m-0"></p-divider>
      </div>
    </ng-container>

    <!-- Button -->
    <ng-container *ngSwitchCase="InputFieldType.Button">
      <div *ngIf="field.showField">
        <button [style]="{'width':'80%', 'maxWidth':'500px'}" pButton pRipple type="button" [label]="field.label"
          [class]="field.class" (click)="field.touched = true; this.onValueChange(fieldValue)">
        </button>
      </div>
    </ng-container>

    <!-- Clear Field Button -->
    <div *ngSwitchCase="InputFieldType.ClearField" class="p-inputgroup" [ngStyle]="{'width': '100%'}">
      <p-button *ngIf="field.clearField && fieldValue" ariaLabel="Clear Field" icon="pi pi-minus"
        styleClass="clear-button p-button-text p-button-danger"
        (click)="field.touched = true; fieldValue = null"></p-button>
    </div>

    <!-- Input Switch -->
    <div class="p-inputgroup " *ngSwitchCase="InputFieldType.InputSwitch">
      <div class="flex-container" *ngIf="field.showField">
        <p class="label">{{field.name}}:</p>
        <p-inputSwitch class="p-mx-2 field-item" [(ngModel)]="fieldValue" [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="field.touched = true; this.onValueChange(this.fieldValue)">
        </p-inputSwitch>
      </div>
    </div>

    <!-- Text/Label -->
    <ng-container *ngIf="field.showField">
      <div *ngSwitchCase="InputFieldType.Text" [id]="field.id" class="p-inputgroup" [ngStyle]="{'width': '100%'}">
        <p class="p-m-0 reduced-line-height" [innerHTML]="field.label | lineBreak"></p>
      </div>
    </ng-container>

    <!-- Number -->
    <ng-container *ngIf="field.showField">
      <div class="p-inputgroup" *ngSwitchCase="InputFieldType.Number" [ngStyle]="{'width': '100%'}">
        <span class="flex-container" style="display: flex; align-items: center;">
          <span class="input-field p-float-label flex-grow">
            <p-inputNumber [(ngModel)]="fieldValue" [required]="field.isRequired" [inputId]="field.inputNumberInputId"
              [minFractionDigits]="field.useMinFractionDigits ? field.minFractionDigits : null" [maxFractionDigits]="field.useMaxFractionDigits ? field.maxFractionDigits : null"
              [mode]="field.inputNumberMode" [showButtons]="field.inputNumberShowButtons" [min]="field.useInputNumberMin ? field.inputNumberMin : null"
              [max]="field.useInputNumberMax ? field.inputNumberMax : null" (ngModelChange)="field.touched = true; this.onValueChange(this.fieldValue)">
            </p-inputNumber>
            <label for="number">{{ field.label }} <strong *ngIf="field.isRequired" style="color: crimson">*</strong></label>
            <p-button *ngIf="field.clearField && fieldValue" ariaLabel="Clear Field" icon="pi pi-minus"
              styleClass="clear-button p-button-text p-button-danger" (click)="clearField(field.key)"
              style="margin-left: 8px;">
            </p-button>
          </span>
        </span>
      </div>
    </ng-container>

    <!-- Text  -->
    <ng-container *ngSwitchCase="InputFieldType.TextInput">
      <span class="flex-container" *ngIf="field.showField">
        <span class="input-field p-float-label flex-grow">
          <input [(ngModel)]="fieldValue" pInputText
            (ngModelChange)="field.touched = true; this.onValueChange(this.fieldValue)" class="field-item"
            [disabled]="field.disabled && this.isEdit" [pTooltip]="field.pTooltip" [tooltipPosition]="field.tooltipPosition" />
          <label for="name">{{ field.label }} <strong *ngIf="field.isRequired" style="color: crimson">*</strong></label>
        </span>
        <p-button *ngIf="field.clearField && fieldValue" ariaLabel="Clear Field" icon="pi pi-minus"
          styleClass="clear-button p-button-text p-button-danger" (click)="this.onValueChange(null)"></p-button>
      </span>
    </ng-container>

    <!-- Color Picker Input -->
    <ng-container *ngSwitchCase="InputFieldType.ColorPicker">
      <div *ngIf="field.showField" class="flex-container">
        <div class="color-picker-wrapper">
          <p-colorPicker appendTo="body" [(ngModel)]="fieldValue" (ngModelChange)="this.onValueChange(this.fieldValue)"
            (onHide)="this.onValueChange(this.fieldValue)">
          </p-colorPicker>
        </div>
        <div class="input-field-wrapper">
          <span class="input-field-label p-float-label">
            <input [(ngModel)]="fieldValue" pInputText type="text" class="field-item" id="colorText"
              (ngModelChange)="this.onValueChange(this.fieldValue)">
            <label for="colorText">{{ field.label }}</label>
          </span>
        </div>
        <i *ngIf="field.pTooltip" class="pi pi-info-circle tooltip-icon" [pTooltip]="field.pTooltip"
          [tooltipPosition]="field.tooltipPosition || 'top'"></i>
        <p-button *ngIf="field.clearField && fieldValue" ariaLabel="Clear Field" icon="pi pi-minus"
          styleClass="clear-button p-button-text p-button-danger" (click)="clearField(field.key)"></p-button>
      </div>
    </ng-container>

    <!-- Toggle Button -->
    <ng-container *ngSwitchCase="InputFieldType.ToggleButton">
      <div *ngIf="field.showField">
        <label *ngIf="field.name">{{ field.name }}</label>
        <div class="toggle-button-wrapper" [style]="field.style">
          <p-toggleButton [(ngModel)]="fieldValue" (onChange)="this.onValueChange(this.fieldValue)" [id]="field.id"
            [onLabel]="field.onLabel" [offLabel]="field.offLabel" [disabled]="field.disabled"></p-toggleButton>
        </div>
      </div>
    </ng-container>


    <!-- Calendar/Date Input -->
    <ng-container *ngSwitchCase="InputFieldType.Calendar">
      <div *ngIf="field.showField" class="flex-container" [ngStyle]="{'width': '100%'}">
        <span class="calendar-input p-float-label">
          <p-calendar [(ngModel)]="fieldValue" appendTo="body" [showTime]="field.calendarShowTime" [disabled]="field.disabled"
            [yearNavigator]="field.calendarYearNavigatior" [yearRange]="field.calendarYearRange" [monthNavigator]="true"
            [showButtonBar]="true" class="field-item" [showClear]="true"
            [selectOtherMonths]="field.calendarSelectOtherMonths" [ngModelOptions]="{ standalone: true }"
            [defaultDate]="field.calendarDefaultDate ? field.calendarDefaultDate : defaultDate"
            [minDate]="field.calendarMinDate ? minEndDate : null"
            (onSelect)="field.touched = true; this.onValueChange(fieldValue)"
            (onInput)="field.touched = true; this.onValueChange(fieldValue); debounceHandleDateInputChange(field.key, $event)"
            (onClearClick)="field.touched = true; clearField(field.key)" [showIcon]="false"
            [hideOnDateTimeSelect]="false" [pTooltip]="field.pTooltip">
            <ng-template pTemplate="footer">
              <button type="button" (click)="resetTime()" class="p-button p-component p-button-text">Reset
                Time</button>
            </ng-template>
          </p-calendar>
          <label for="calendar"> {{ field.label }} <strong *ngIf="field.isRequired"
              style="color: crimson">*</strong></label>
        </span>
        <div style="width: 2rem;" class="p-mr-2">
          <p-button *ngIf="field.clearField && fieldValue" ariaLabel="Clear Field" icon="pi pi-minus"
            styleClass="clear-button p-button-text p-button-danger" (click)="clearField(field.key);"></p-button>
        </div>
      </div>
    </ng-container>


    <!-- Time  -->
    <ng-container *ngSwitchCase="InputFieldType.Time">
      <span class="flex-container" *ngIf="field.showField">
        <span class="input-field p-float-label flex-grow">
          <input [(ngModel)]="fieldValue" pInputText type="time"
            (ngModelChange)="field.touched = true; this.onValueChange(this.fieldValue)" class="field-item"
            [disabled]="field.disabled && this.isEdit" />
          <label for="name">{{ field.label }} <strong *ngIf="field.isRequired" style="color: crimson">*</strong></label>
        </span>
        <p-button *ngIf="field.clearField && fieldValue" ariaLabel="Clear Field" icon="pi pi-minus"
          styleClass="clear-button p-button-text p-button-danger" (click)="this.onValueChange(null)"></p-button>
      </span>
    </ng-container>

    <!-- Multi-Select -->
    <ng-container *ngSwitchCase="InputFieldType.MultiSelect">
      <div *ngIf="field.showField" class="flex-container">
        <div class="input-field-wrapper">
          <span class="p-float-label" [class.p-float-label-empty]="!fieldValue || fieldValue.length === 0">
            <p-multiSelect [(ngModel)]="fieldValue" (ngModelChange)="this.onValueChange(this.fieldValue)"
              [options]="field.filterBy?.includes(',') ? getOptionsForMultiFieldFilter() : options[field.key]" 
              [optionLabel]="field.filterBy?.includes(',') ? '_searchLabel' : field.optionLabel" 
              [optionValue]="field.optionValue"
              [optionDisabled]="field.optionDisabled" display="chip" filter="true" 
              [filterBy]="field.filterBy?.includes(',') ? '_searchLabel' : field.filterBy"
              filterMatchMode="contains"
              [ngStyle]="{'width': '100%'}" [placeholder]="' '" [maxSelectedLabels]="field.maxSelectedLabels || 99">
              <!-- Template for selected items -->
              <ng-template let-value pTemplate="selectedItem">
                <ng-container *ngIf="getOptionByValue(value, field.key, field.optionValue) as option">
                  <ng-container *ngFor="let key of field.labelKeys">
                    <span *ngIf="key === 'id'">({{ option[key] }})</span>
                    <span *ngIf="key === 'name'"><strong> {{ option[key] }}</strong></span>
                    <span *ngIf="key !== 'id' && key !== 'name'">{{ option[key] }}</span>
                  </ng-container>
                  <!-- No labelKeys: fall back to the option's label rather than printing nothing (CMS-6338). -->
                  <span *ngIf="!field.labelKeys?.length">{{ optionText(option) }}</span>
                </ng-container>
                <ng-container *ngIf="!getOptionByValue(value, field.key, field.optionValue)">
                  {{ value }}
                </ng-container>
              </ng-template>
              <!-- Template for items in dropdown -->
              <ng-template let-option pTemplate="item">
                <div *ngIf="isObject(option)">
                  <ng-container *ngFor="let key of field.labelKeys">
                    <span *ngIf="key === 'id'">({{ option[key] }})</span>
                    <span *ngIf="key === 'name'"><strong> {{ option[key] }}</strong></span>
                    <span *ngIf="key !== 'id' && key !== 'name'"> {{ option[key] }}</span>
                  </ng-container>
                  <!-- No labelKeys: fall back to the option's label rather than a blank row (CMS-6338). -->
                  <span *ngIf="!field.labelKeys?.length">{{ optionText(option) }}</span>
                </div>
                <div *ngIf="!isObject(option)">
                  {{ option }} <!-- Directly display the string -->
                </div>
              </ng-template>
            </p-multiSelect>

            <label for="multiselect">{{ field.label }} <strong *ngIf="field.isRequired"
                style="color: crimson">*</strong></label>
          </span>
        </div>
        <div class="multiselect-buttons">
          <p-button *ngIf="field.clearField && fieldValue && fieldValue.length > 0" ariaLabel="Clear Field" icon="pi pi-minus"
            styleClass="clear-button p-button-text p-button-danger" (click)="clearField(field.key)">
          </p-button>
          <p-button icon="pi pi-eye" (click)="showSelectedItems()" class="small-eye-button"></p-button>
        </div>
      </div>

      <p-dialog header="Selected Items" [(visible)]="isDialogVisible" [modal]="true" [closable]="true"
        [style]="{width: '500px'}">
        <ul>
          <li *ngFor="let item of selectedItems">
            <ng-container *ngIf="item.link">
              <a [routerLink]="item.link" target="_blank" style="color: #91c58a; text-decoration: underline;">
                {{ item.name }} ({{ item.id }})
              </a>
            </ng-container>
            <ng-container *ngIf="!item.link">
              {{ item.name }}
            </ng-container>
          </li>
        </ul>
      </p-dialog>
    </ng-container>


    <!-- Dropdown -->
    <ng-container *ngSwitchCase="InputFieldType.Dropdown">
      <div *ngIf="field.showField" class="p-inputgroup" [ngStyle]="{'width': '100%'}">
        <span ngClass="p-float-label" *ngIf="!field.hideField">
          <!-- PrimeNG 16 bug: filterBy is ignored, only optionLabel is used for filtering.
               When multi-field filtering is needed, we use _searchLabel as optionLabel
               and rely on custom templates to display the actual values. -->
          <p-dropdown [(ngModel)]="fieldValue" (ngModelChange)="onValueChange($event)" 
            [options]="field.filterBy?.includes(',') ? getOptionsForMultiFieldFilter() : options[field.key]" 
            [optionLabel]="field.filterBy?.includes(',') ? '_searchLabel' : field.optionLabel" 
            [optionValue]="field.optionValue"
            [autoDisplayFirst]="field.autoDisplayFirst" [filter]="field.filter" 
            [filterBy]="field.filterBy?.includes(',') ? '_searchLabel' : field.filterBy"
            filterMatchMode="contains"
            [group]="field.dropdownGroup" [scrollHeight]="field.scrollHeight || '200px'" [showClear]="field.showClear"
            [disabled]="field.disabled">

            <ng-template let-option pTemplate="selectedItem">
              <div *ngIf="option">
                <span *ngIf="option.id">({{ option.id }})</span>
                <span *ngIf="option[field.optionLabel || 'name']"><strong> {{ option[field.optionLabel || 'name'] }} </strong></span>
                <span *ngIf="option[field.optionSubLabel]"> - {{ option[field.optionSubLabel] }}</span>
                <span *ngIf="option.path"> - {{ option.path }}</span>
              </div>
            </ng-template>

            <ng-template let-option pTemplate="item">
              <div *ngIf="option">
                <span *ngIf="option.id">({{ option.id }})</span>
                <span *ngIf="option[field.optionLabel || 'name']"><strong> {{ option[field.optionLabel || 'name'] }} </strong></span>
                <span *ngIf="option[field.optionSubLabel]"> - {{ option[field.optionSubLabel] }}</span>
                <span *ngIf="option.path"> - {{ option.path }}</span>
              </div>
            </ng-template>
          </p-dropdown>
          <label>{{ field.label }}</label>
        </span>
      </div>
    </ng-container>

    <!-- Query Dropdown -->
    <ng-container *ngSwitchCase="InputFieldType.queryDropdown">
      <div *ngIf="field.showField" class="p-inputgroup">
        <span ngClass="p-float-label" *ngIf="!field.hideField">
          <p-dropdown [(ngModel)]="fieldValue" (ngModelChange)="this.onValueChange(this.fieldValue);"
            [options]="field.filterBy?.includes(',') ? getOptionsForMultiFieldFilter() : options[field.key]" 
            [optionLabel]="field.filterBy?.includes(',') ? '_searchLabel' : field.optionLabel" 
            [optionValue]="field.optionValue"
            [autoDisplayFirst]="field.autoDisplayFirst" [filter]="field.filter" 
            [filterBy]="field.filterBy?.includes(',') ? '_searchLabel' : field.filterBy"
            filterMatchMode="contains"
            [group]="field.dropdownGroup" [scrollHeight]="field.scrollHeight || '200px'" [showClear]="field.showClear"
            [disabled]="field.disabled">

            <!-- Conditionally render (id) Name: name | Path: path -->
            <ng-container *ngFor="let template of ['item', 'selectedItem']">
              <ng-template [pTemplate]="template" let-option>
                <ng-container *ngIf="option">
                  <ng-container *ngIf="field.options?.isdisplayNameIDPath; else defaultTemplate">
                    ({{option.id}}) <strong>Name:</strong> {{option.name}}
                    <span *ngIf="option.path">| <strong>Path:</strong> {{option.path}} </span> 
                  </ng-container>
                  <ng-template #defaultTemplate>
                    {{option[field.optionLabel]}} <!-- Render default label if the condition is false -->
                  </ng-template>
                </ng-container>
              </ng-template>
            </ng-container>
          </p-dropdown>

          <label for="dropdown">
            {{ field.label }}
            <strong *ngIf="field.isRequired" style="color: crimson">*</strong>
          </label>
        </span>

        <p-button *ngIf="field.clearField && fieldValue" ariaLabel="Clear Field" icon="pi pi-minus"
          styleClass="clear-button p-button-text p-button-danger" (click)="clearField(field.key)">
        </p-button>
      </div>
    </ng-container>

    <!-- AutoComplete -->
    <ng-container *ngSwitchCase="InputFieldType.AutoComplete">
      <div *ngIf="field.showField" class="p-inputgroup" [ngStyle]="{'width': '100%'}">
        <span ngClass="p-float-label" *ngIf="!field.hideField">
          <p-autoComplete #itemsInput [(ngModel)]="fieldValue" [multiple]="field.autocompleteMultipleValues" appendTo="body"
            (ngModelChange)="this.onValueChange(this.fieldValue);"
            (onSelect)="this.onValueChange(this.fieldValue);"
            (onUnselect)="this.onValueChange(this.fieldValue);"
            (onClear)="this.onValueChange(this.fieldValue);"
            (completeMethod)="getSuggestionsForRef(
              $event.query,
              field.suggestions.fieldName,
              field.suggestions.apiController,
              field.suggestions.minimal,
              field.suggestions.autopopulate,
              field.suggestions.sort,
              field.suggestions.virtuals,
              field.suggestions.select,
              field.suggestions.customQuery,
              field.suggestions.customQueryField,
              field.suggestions.isMiscAsset)
            "
            [suggestions]="suggestions[field.suggestions.fieldName]" 
            [showEmptyMessage]="field.autocompleteShowEmptyMessage"
            [field]="field.autocompleteField" [minLength]="field.autocompleteMinLength" [ngStyle]="{'width': '100%'}"
            [showClear]="field.showClear" 
            [dropdown]="field.dropdown && !field.autocompleteMultipleValues"
            [forceSelection]="field.forceSelection"
            [delay]="field.delay"
            [scrollHeight]="field.scrollHeight || '200px'"
            [emptyMessage]="field.emptyMessage"
            [disabled]="field.disabled"
            (keydown)="onKeyDown($event)"
            >
            <ng-template let-item pTemplate="item">
              <div *ngIf="item">
                <span *ngIf="item.id">({{ item.id }})</span>
                <span *ngIf="item[field.autocompleteField]"><strong> {{ item[field.autocompleteField] }}</strong></span>
                <span *ngIf="item.path"> - {{ item.path }}</span>
              </div>
            </ng-template>

            <ng-template let-value pTemplate="selectedItem">
              <div *ngIf="value">
                <span *ngIf="value.id">({{ value.id }})</span>
                <span *ngIf="value[field.autocompleteField]"><strong> {{ value[field.autocompleteField] }}</strong></span>
                <span *ngIf="value.path"> - {{ value.path }}</span>
              </div>
            </ng-template>
          </p-autoComplete>
          <label>{{ field.label }}</label>
        </span>
      </div>
      <ng-container *ngIf="fieldValue && fieldValue.id && fieldValue.path" class="p-mx-3">
        <div class="autocomplete-info-card p-d-flex p-ai-center p-p-2 p-mt-2">
          <!-- <img *ngIf="fieldValue.path.endsWith('.jpg') || fieldValue.path.endsWith('.png')"
               [src]="fieldValue.path"
               alt="Preview"
               style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px; margin-right: 12px;"> -->
          <div>
            <div>
              <span class="p-text-secondary" style="font-size: 0.85em;">ID: {{ fieldValue.id }}</span>
            </div>
            <div>
              <span class="p-text-bold" style="font-size: 1.1em;">{{ fieldValue.name }}</span>
            </div>
            <div>
              <span class="p-text-light" style="font-size: 0.85em;">{{ fieldValue.path }}</span>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="fieldValue && fieldValue.id && !fieldValue.path && field.suggestions?.showInfoCard" class="p-mx-3">
        <div class="autocomplete-info-card p-d-flex p-ai-center p-p-2 p-mt-2">
          <div>
            <div>
              <span class="p-text-secondary" style="font-size: 0.85em;">ID: {{ fieldValue.id }}</span>
            </div>
            <div>
              <span class="p-text-bold" style="font-size: 1.1em;">{{ fieldValue.name }}</span>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Reorderable list for autocomplete selected items -->
      <div *ngIf="field.reorderable && field.autocompleteMultipleValues && fieldValue && fieldValue.length > 0" class="autocomplete-reorder-list">
        <div class="reorder-header" (click)="reorderExpanded = !reorderExpanded">
          <i class="pi" [ngClass]="reorderExpanded ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          <span>Reorder ({{ fieldValue.length }})</span>
        </div>
        <div class="reorder-items" *ngIf="reorderExpanded">
          <div *ngFor="let item of fieldValue; let i = index" 
               class="reorder-item"
               [pDraggable]="'autocomplete-' + field.key"
               [pDroppable]="'autocomplete-' + field.key"
               (onDragStart)="onMultiselectDragStart(i)"
               (onDrop)="onMultiselectDrop(i)">
            <i class="pi pi-bars reorder-drag-handle"></i>
            <span class="reorder-item-label">
              <span *ngIf="item.id">({{ item.id }})</span>
              <span *ngIf="item.name"><strong> {{ item.name }}</strong></span>
              <span *ngIf="item.path"> - {{ item.path }}</span>
            </span>
            <i class="pi pi-times reorder-remove" (click)="removeMultiselectItem(i)"></i>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Input Text Area (Long Text Input) -->
    <div *ngSwitchCase="InputFieldType.InputTextArea" class="flex-container">
      <span ngClass="p-float-label" *ngIf="field.showField" class="textarea-container">
        <ng-container *ngIf="field?.options?.showCharacterCount">
          <span class="character-count">
            <span class="text">Character Count: {{ fieldValue?.length ? fieldValue?.length : 0 }}</span>
            <span class="error"
              *ngIf="field.options.characterCountValidFunction && !field.options.characterCountValidFunction(fieldValue).valid">
              {{ field.options.characterCountValidFunction(fieldValue).message }}
            </span>
          </span>
        </ng-container>
        <textarea id="text-area" [(ngModel)]="fieldValue" (ngModelChange)="this.onValueChange(this.fieldValue)"
          [disabled]="field.disabled" [cols]="field.inputTextAreaCols ? field.inputTextAreaCols : null"
          [rows]="field.inputTextAreaRows ? field.inputTextAreaRows : 10" pInputTextarea class="field-item">
        </textarea>
        <label for="text-area"> {{ field.label }} <strong *ngIf="field.isRequired"
            style="color: crimson">*</strong></label>
      </span>
      <p-button *ngIf="field.clearField && fieldValue" ariaLabel="Clear Field" icon="pi pi-minus"
        styleClass="clear-button p-button-text p-button-danger" (click)="clearField(field.key)"></p-button>
    </div>

    <!-- Editor -->
    <ng-container *ngSwitchCase="InputFieldType.Editor">
      <div *ngIf="field.showField" class="p-mx-5">
        <h5>{{ field.label }}</h5>
        <div class="flex-container p-my-5" style="align-items: flex-start;">
          <div class="input-field-wrapper" style="flex-grow: 1; margin-right: 0.5em;">
            <span class="p-float-label">
              <p-editor [(ngModel)]="fieldValue" [style]="field.style"
                (ngModelChange)="this.onValueChange(this.fieldValue)"
                (onSelectionChange)="this.onValueChange(this.fieldValue)">
                <ng-template pTemplate="header">
                  <span class="ql-formats">
                    <select class="ql-header p-mr-2" aria-label="Header"></select>
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline p-mr-2" aria-label="Underline"></button>
                    <select class="ql-color" aria-label="Color"></select>
                    <select class="ql-background p-mr-2" aria-label="Background Color"></select>
                    <button class="ql-list" value="ordered" aria-label="Ordered List"></button>
                    <button class="ql-list" value="bullet" aria-label="Unordered List"></button>
                    <button class="ql-link p-mr-2" aria-label="Insert Link"></button>
                  </span>
                </ng-template>
              </p-editor>
            </span>
          </div>
          <p-button *ngIf="field.clearField && fieldValue" ariaLabel="Clear Field" icon="pi pi-minus"
            styleClass="clear-button p-button-text p-button-danger" (click)="clearField(field.key)"
            [ngStyle]="{'margin-left': 0, 'padding': 0}"></p-button>
        </div>
      </div>
    </ng-container>

    <!-- Checkbox Input -->
    <ng-container *ngSwitchCase="InputFieldType.CheckBox">
      <div *ngIf="field.showField" class="p-inputgroup" [ngStyle]="{'width': '100%'}">
        <span ngClass="p-field-checkbox">
          <p-checkbox [(ngModel)]="fieldValue" [inputId]="field.inputId" [binary]="field.checkboxBinary"
            (onChange)="this.onValueChange(this.fieldValue); field.touched = true; ">
          </p-checkbox>
          <label for="checkbox"><strong> {{ field.label }} </strong><strong *ngIf="field.isRequired"
              style="color: crimson">*</strong></label>
        </span>
        <p-button *ngIf="field.clearField && fieldValue" ariaLabel="Clear Field" icon="pi pi-minus"
          styleClass="p-button-text p-button-danger" (click)="field.touched = true; fieldValue = null"></p-button>
      </div>
    </ng-container>

    <!-- Table Input -->
    <ng-container *ngSwitchCase="InputFieldType.TableInput">
      <div *ngIf="field.showField">
        <table-input [field]="field" [record]="record" [isTableInput]="isTableInput" [entityType]="entityType"
          [deficolumn]="field.deficolumn" [options]="options" (onChange)="handleItemsRefChange($event)">
        </table-input>
      </div>
    </ng-container>


    <!-- Checkboxv2 Input -->
    <ng-container *ngSwitchCase="InputFieldType.Checkboxv2">
      <div *ngIf="field.showField && !field.hideField" class="p-field-checkbox">
        <p-checkbox [(ngModel)]="fieldValue" binary="true" [inputId]="field.inputId"
          (onChange)="onValueChange(fieldValue); field.touched = true"></p-checkbox>
        <label for="{{field.inputId}}"><strong>{{ field.label }}</strong><strong *ngIf="field.isRequired"
            style="color: crimson">*</strong></label>
      </div>
    </ng-container>



    <!-- CHIPS -->
    <ng-container *ngSwitchCase="InputFieldType.Chip">
      <div *ngIf="field.showField" class="flex-container">
        <div class="chips-container ">
          <small>{{ field.label }}</small>
          <p-chips [(ngModel)]="fieldValue" (onAdd)="this.onValueChange(this.fieldValue)"
            (onRemove)="this.onValueChange(this.fieldValue)" [addOnTab]="true" [addOnBlur]="true" separator=","
            [showClear]="true" [ngStyle]="{'width': '100%'}">
          </p-chips>
        </div>
        <p-button *ngIf="field.clearField && fieldValue" ariaLabel="Clear Field" icon="pi pi-minus"
          styleClass="clear-button p-button-text p-button-danger" (click)="clearField(field.key)"></p-button>
      </div>
    </ng-container>

    <!-- Repetitive Events -->

    <ng-container *ngSwitchCase="InputFieldType.RepetitiveEvents">
      <!-- Toggle for Is Repetitive -->
      <div *ngIf="field.showField">
        <div class="toggle-button-wrapper">
          <p-toggleButton [(ngModel)]="fieldValue" (onChange)="this.onValueChange(this.fieldValue)"
            [onLabel]="field.onLabel" [offLabel]="field.offLabel" [disabled]="field.disabled">
          </p-toggleButton>
        </div>
      </div>
    </ng-container>

    <!-- Multiple Checkbox -->

    <ng-container *ngSwitchCase="InputFieldType.MultipleCheckbox">
      <div *ngIf="field.showField">
        <small class="p-ml-3 inline-element">{{ field.helperText }}</small>
        <div class="p-ml-2">
          <div *ngFor="let day of field.options.values" class="field-checkbox p-my-1">
            <p-checkbox [label]="day.label" [binary]="true" [ngModel]="isDaySelected(day.value)"
              (onChange)="toggleDaySelection(day.value)">
            </p-checkbox>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Listbox -->

    <div *ngSwitchCase="InputFieldType.ListBox">
      <div class="p-grid" [ngStyle]="{'max-width': '80vw'}" *ngIf="field.showField">
        <div class="form-field-col form-field-col-6">
          <p-listbox #listboxEl [options]="options" [(ngModel)]="fieldValue" [metaKeySelection]="false" [checkbox]="true"
            [filter]="true" [multiple]="true" optionLabel="name" optionValue="_id"
            (onChange)="this.onValueChange(this.fieldValue)" [listStyle]="{'max-height':'150px'}"
            [style]="{'width':'25rem'}"
            [filterValue]="listboxFilterValue"
            (onFilter)="listboxFilterValueChange.emit($event.filter)">
            <ng-template let-item pTemplate="item">
              <div class="item-item" *ngIf="item">
                <div>{{item.name}}</div>
              </div>
            </ng-template>
          </p-listbox>
        </div>
        <div class="form-field-col form-field-col-6">
          <h4>Selected: </h4>
          <ul>
            <li class="p-my-1" *ngFor="let i of fieldValue">
              {{transform(i)}}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- MultiTextInput -->

    <ng-container *ngSwitchCase="InputFieldType.MultiTextInput">
      <span class="flex-container" *ngIf="field.showField">
        <div>
          <p-fieldset class="p-formgroup-inline">
            <ng-template pTemplate="header">
              <div class="p-formgroup-inline">
                <span class="p-my-auto p-mr-2">{{ field.label }}</span>
                <button pButton icon="pi pi-plus p-panel-header-icon"
                  class="p-button-rounded p-button-text p-button"
                  (click)="addOneMultiTextInput()"
                  type="button"></button>
              </div>
            </ng-template>
            <span class="p-formgroup-inline">
              <div *ngFor="
                      let subInput of fieldValue;
                      let pointIndex = index;
                      trackBy: trackByIndexMultiTextInput">
                <p-card class="p-formgroup p-m-2 p-shadow-4">
                  <ng-template pTemplate="content">
                    <div class="p-mx-5 flex-container">
                      <span [style]="{ 'min-width': '16.5em' }" ngClass="p-float-label">
                        <input pInputText class="field-item" [(ngModel)]="fieldValue[pointIndex]"
                          (ngModelChange)="this.onMultiTextInputValueChange(pointIndex, $event)"
                          [disabled]="field.disabled && this.isEdit"/>
                        <label for="subInput"> Link </label>
                      </span>
                      <p-button *ngIf="field.clearField && fieldValue" ariaLabel="Clear Field" icon="pi pi-minus"
                        styleClass="clear-button p-button-text p-button-danger" (click)="this.onMultiTextInputValueChange(pointIndex, null)"></p-button>
                    <button pButton type="button" icon="pi pi-times"
                      class="p-button-rounded p-button-text p-button-danger float-right"
                      (click)="deleteOneMultiTextInput(pointIndex)"></button>
                    </div>
                  </ng-template>
                </p-card>
              </div>
            </span>
          </p-fieldset>
        </div>
      </span>
    </ng-container>

    <!-- Animation Trigger Map -->
    <ng-container *ngSwitchCase="InputFieldType.AnimationTriggerMap">
      <div *ngIf="field.showField">
        <app-animation-trigger-map-input
          [field]="field"
          [record]="record"
          [value]="fieldValue"
          (valueChange)="onValueChange($event)">
        </app-animation-trigger-map-input>
      </div>
    </ng-container>

    <!-- Costs / Prizes / Entry Payouts -->
    <ng-container *ngSwitchCase="InputFieldType.Prize">
      <span class="flex-container" *ngIf="field.showField">
        <prizes-card-form-group [fieldsetName]="field.label" [defaultResourceType]="field.defaultResourceType || null"
          [(prize)]="fieldValue" [showPrize]="true" [isCostField]="field.isCostField"
          [isChallenge]="field.isChallenge" [isChallengePrize]="field.isChallengePrize" (onPrizeChange)="onPrizeChange($event)">
        </prizes-card-form-group>
      </span>
    </ng-container>
  </ng-container>
</ng-container>
<p-toast></p-toast>